import { inject, type InjectionKey } from 'vue';
import type { WebModule } from './module.ts';

// The modules compiled into this build, for a page that lists what others contribute
// (ADR 0015) without importing them. apps/web provides them, as only it knows them.

export const MODULES_KEY: InjectionKey<readonly WebModule[]> = Symbol('itc-modules');

/** Every web module, or none outside the app. */
export function useModules(): readonly WebModule[] {
  return inject(MODULES_KEY, []);
}
